// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment__sumaryTitle {
  font-size: 1.25rem;
  color: var(--clr-primary);
  font-family: "Avenir Next";
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.payment__sumary {
  padding: 1.5em;
  background: var(--clr-gray300);
  border-radius: 1em;
  margin: 1.5rem 0;
}

/* .payment__sumaryData li + li {
    margin-bottom: 2rem;
  } */

.payment__sumary.decoration .payment__sumaryData {
  display: block;
}
.payment__sumary.decoration .payment__sumaryLabel {
  display: flex;
  margin-top: 1rem;
}
.payment__sumaryData {
  display: grid;
  gap: 1rem;
  margin-top: 1.25rem;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
}

.payment__sumaryData li {
  display: flex;
  flex-direction: column;
}

.payment__sumaryLabel {
  display: flex;
  align-items: center;
  font-weight: 600 !important;
  width: 100%;
  margin-bottom: 0.25rem;
  color: var(--clr-primary);
}

.payment__sumaryDataList li {
  display: inline;
  list-style: disc;
}

.payment__sumaryDataList ul {
  padding-left: 1em;
}

.payment__summaryInput,
.payment__sumaryData li input {
  /* font-size: 1.1rem;
  background: transparent;
  outline: none;
  padding: 0.25em;
  margin-left: -0.25rem; */

  border: 0.1rem solid var(--clr-dark);
  background: var(--clr-light);
}

.payment__summaryInput {
  padding: 0.5em;
  font-size: 1rem;
  border-radius: 0.5em;
}

.payment__sumaryData li span {
  font-size: 1rem;
  font-weight: 500;
}

.payment__sumaryData li input.edit {
  border: 0.1rem solid var(--clr-dark);
  background: var(--clr-light);
  border-radius: 0.5em;
}

.payment__sumaryLabel svg {
  width: 1rem;
  cursor: pointer;
  margin-left: 0.25rem;
}

/* edit date */

.payment__summaryEditDate {
  display: flex;
  margin-top: 0.25rem;
}

.payment__summaryEditDate .inputLabelFloat:first-of-type {
  margin-right: 1rem;
}

.payment__sumaryLabel i {
  margin-bottom: -0.5rem;
  margin-left: 0.75rem;
}

.payment__sumaryActivity {
  display: flex;
  align-items: center;
}

.payment__sumaryActivity svg {
  width: 0.75rem;
  margin-left: 0.25rem;
  margin-bottom: -0.15rem;
}

.payment__sumaryActivity.cursor-click {
  cursor: pointer;
}

.payment__sumaryActivity.show svg {
  transform: rotate(180deg);
}

@media (min-width: 475px) {
  .payment__sumaryData li:last-of-type,
  .payment__sumaryData li:first-of-type {
    grid-column: span 2;
  }

  .payment__sumaryData.option li:first-of-type {
    grid-column: unset;
  }
}

@media (min-width: 768px) {
  .payment__sumaryData {
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  }
}

@media (min-width: 992px) {
  .payment__sumary {
    max-width: 35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PaymentSummary/PaymentSummary.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;KAEK;;AAEL;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;;;;0BAIwB;;EAExB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".payment__sumaryTitle {\n  font-size: 1.25rem;\n  color: var(--clr-primary);\n  font-family: \"Avenir Next\";\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.payment__sumary {\n  padding: 1.5em;\n  background: var(--clr-gray300);\n  border-radius: 1em;\n  margin: 1.5rem 0;\n}\n\n/* .payment__sumaryData li + li {\n    margin-bottom: 2rem;\n  } */\n\n.payment__sumary.decoration .payment__sumaryData {\n  display: block;\n}\n.payment__sumary.decoration .payment__sumaryLabel {\n  display: flex;\n  margin-top: 1rem;\n}\n.payment__sumaryData {\n  display: grid;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));\n}\n\n.payment__sumaryData li {\n  display: flex;\n  flex-direction: column;\n}\n\n.payment__sumaryLabel {\n  display: flex;\n  align-items: center;\n  font-weight: 600 !important;\n  width: 100%;\n  margin-bottom: 0.25rem;\n  color: var(--clr-primary);\n}\n\n.payment__sumaryDataList li {\n  display: inline;\n  list-style: disc;\n}\n\n.payment__sumaryDataList ul {\n  padding-left: 1em;\n}\n\n.payment__summaryInput,\n.payment__sumaryData li input {\n  /* font-size: 1.1rem;\n  background: transparent;\n  outline: none;\n  padding: 0.25em;\n  margin-left: -0.25rem; */\n\n  border: 0.1rem solid var(--clr-dark);\n  background: var(--clr-light);\n}\n\n.payment__summaryInput {\n  padding: 0.5em;\n  font-size: 1rem;\n  border-radius: 0.5em;\n}\n\n.payment__sumaryData li span {\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.payment__sumaryData li input.edit {\n  border: 0.1rem solid var(--clr-dark);\n  background: var(--clr-light);\n  border-radius: 0.5em;\n}\n\n.payment__sumaryLabel svg {\n  width: 1rem;\n  cursor: pointer;\n  margin-left: 0.25rem;\n}\n\n/* edit date */\n\n.payment__summaryEditDate {\n  display: flex;\n  margin-top: 0.25rem;\n}\n\n.payment__summaryEditDate .inputLabelFloat:first-of-type {\n  margin-right: 1rem;\n}\n\n.payment__sumaryLabel i {\n  margin-bottom: -0.5rem;\n  margin-left: 0.75rem;\n}\n\n.payment__sumaryActivity {\n  display: flex;\n  align-items: center;\n}\n\n.payment__sumaryActivity svg {\n  width: 0.75rem;\n  margin-left: 0.25rem;\n  margin-bottom: -0.15rem;\n}\n\n.payment__sumaryActivity.cursor-click {\n  cursor: pointer;\n}\n\n.payment__sumaryActivity.show svg {\n  transform: rotate(180deg);\n}\n\n@media (min-width: 475px) {\n  .payment__sumaryData li:last-of-type,\n  .payment__sumaryData li:first-of-type {\n    grid-column: span 2;\n  }\n\n  .payment__sumaryData.option li:first-of-type {\n    grid-column: unset;\n  }\n}\n\n@media (min-width: 768px) {\n  .payment__sumaryData {\n    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n  }\n}\n\n@media (min-width: 992px) {\n  .payment__sumary {\n    max-width: 35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
